import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { OutboundLink } from 'gatsby-plugin-google-gtag'

const Menu = (props) => (
  <nav id='menu'>
    <div className='inner'>
      <ul className='links'>
        <li>
          <Link
            onClick={props.onToggleMenu}
            to='/'
            aria-label='Home'
            title='Website Design Company'
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            onClick={props.onToggleMenu}
            to='/about/'
            aria-label='About'
            title='About Us And Our Web Design Company'
          >
            About
          </Link>
        </li>
        <li>
          <Link
            onClick={props.onToggleMenu}
            to='/services/'
            aria-label='Services'
            title='Website Design Services'
          >
            Services
          </Link>
        </li>
        <li>
          <Link
            onClick={props.onToggleMenu}
            to='/portfolio/'
            aria-label='Portfolio'
            title='Website Design Porfolio'
          >
            Portfolio
          </Link>
        </li>
        <li>
          <Link
            onClick={props.onToggleMenu}
            to='/custom-web-development/'
            aria-label='Custom Web Development'
            title='Custom Website Development'
          >
            Custom Web Development
          </Link>
        </li>
      </ul>
      <ul className='actions vertical'>
        <li>
          <OutboundLink
            href='https://www.blackalsatian.co.za/'
            className='button special fit'
            target='_blank'
            rel='noopener noreferrer'
            title='Web design company &amp; Online marketing agency'
            aria-label='Visit Our ZA Site'
          >
            Visit Our ZA Site
          </OutboundLink>
        </li>
      </ul>
    </div>
    <button className='close' onClick={props.onToggleMenu} aria-label='Close'>
      Close
    </button>
  </nav>
)

Menu.propTypes = {
  onToggleMenu: PropTypes.func,
}

export default Menu
